import React from 'react';
import {
  EntryRoot,
  Brand,
  Tagline,
  Actions,
  ModeButton,
  Hint,
} from './entryStyles';

const EntryScreen = ({ onChoose }) => (
  <EntryRoot>
    <Brand>Milkway</Brand>
    <Tagline>Choose how to enter</Tagline>
    <Actions>
      <ModeButton type="button" primary onClick={() => onChoose('play')}>
        Play
      </ModeButton>
      <ModeButton type="button" onClick={() => onChoose('demo')}>
        Demo
      </ModeButton>
    </Actions>
    <Hint>Demo guides you through the main steps of the game.</Hint>
  </EntryRoot>
);

export default EntryScreen;
